<nb-list>
  @for (lesson of lessons(); track lesson.id) {
  <nb-list-item class="lessonitem border-0">
    @let state = lessonsProgress()?.lessons[lesson.id];
    <div
      class="d-flex align-items-center w-100"
      nbTooltipPlacement="top"
      [nbTooltip]="state?.tooltip"
      [nbTooltipDisabled]="!state?.tooltip"
      nbTooltipStatus="danger"
      (click)="!state?.locked && goToLesson(lesson)"
      [class.pointer]="!state?.locked"
    >
      @if(icon()) {
      <div class="flex-shrink-0 me-3">
        <nb-icon
          [icon]="state.icon"
          [status]="state.color"
          class="h2 mb-0 align-self-top"
        ></nb-icon>
      </div>
      }
      <div class="flex-grow-1">
        @if (lesson.options.icon) {
        <img
          [src]="lesson.options.icon"
          alt="track"
          class="img-fluid d-inline-block float-start me-1"
          width="22"
        />
        }
        <div class="badge-wrap d-inline mb-2">
          @if (lesson.options.tag.text) {
          <span
            class="badge rounded-pill text-bg-{{
              lesson.options.tag.color
            }} me-2 float-start"
            >{{ lesson.options.tag.text }}
          </span>
          } @if (lesson.options.track) {
          <span class="badge rounded-pill text-bg-info me-2 float-start"
            >Track
            {{ lesson.options.track == 3 ? "1+2" : lesson.options.track }}
          </span>
          }
        </div>
        <h3 class="mb-0 ltitle" [line-truncation]="2">
          {{ lesson.name }}
        </h3>
      </div>
    </div>
  </nb-list-item>
  }
</nb-list>
